.SessionDetailsEditor {
}
